import type { DriverDayOffStatus, DriverDayOffType } from '@/backend/market'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class DriverDayOffFilterEntity {
  driver?: DriverEntity | null
  region?: RegionMiniEntity | null
  status?: DriverDayOffStatus
  type?: DriverDayOffType
  page?: number
  limit?: number
}
